// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../img/all/pointer-zoom-in.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../img/all/pointer-zoom-out.svg");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../img/all/pointer-zoom-off.svg");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../img/all/fullscreenoff.svg");
var ___CSS_LOADER_URL_IMPORT_4___ = require("../img/all/lightbox_close.svg");
var ___CSS_LOADER_URL_IMPORT_5___ = require("../img/basic/left.svg");
var ___CSS_LOADER_URL_IMPORT_6___ = require("../img/basic/right.svg");
var ___CSS_LOADER_URL_IMPORT_7___ = require("../img/basic/up.svg");
var ___CSS_LOADER_URL_IMPORT_8___ = require("../img/basic/down.svg");
var ___CSS_LOADER_URL_IMPORT_9___ = require("../img/basic/play.svg");
var ___CSS_LOADER_URL_IMPORT_10___ = require("../img/basic/pause.svg");
var ___CSS_LOADER_URL_IMPORT_11___ = require("../img/basic/zoomin.svg");
var ___CSS_LOADER_URL_IMPORT_12___ = require("../img/basic/zoomout.svg");
var ___CSS_LOADER_URL_IMPORT_13___ = require("../img/basic/hotspoton.svg");
var ___CSS_LOADER_URL_IMPORT_14___ = require("../img/basic/hotspotoff.svg");
var ___CSS_LOADER_URL_IMPORT_15___ = require("../img/basic/fullscreenon.svg");
var ___CSS_LOADER_URL_IMPORT_16___ = require("../img/retina/left.svg");
var ___CSS_LOADER_URL_IMPORT_17___ = require("../img/retina/right.svg");
var ___CSS_LOADER_URL_IMPORT_18___ = require("../img/retina/up.svg");
var ___CSS_LOADER_URL_IMPORT_19___ = require("../img/retina/down.svg");
var ___CSS_LOADER_URL_IMPORT_20___ = require("../img/retina/play.svg");
var ___CSS_LOADER_URL_IMPORT_21___ = require("../img/retina/pause.svg");
var ___CSS_LOADER_URL_IMPORT_22___ = require("../img/retina/zoomin.svg");
var ___CSS_LOADER_URL_IMPORT_23___ = require("../img/retina/zoomout.svg");
var ___CSS_LOADER_URL_IMPORT_24___ = require("../img/retina/hotspoton.svg");
var ___CSS_LOADER_URL_IMPORT_25___ = require("../img/retina/hotspotoff.svg");
var ___CSS_LOADER_URL_IMPORT_26___ = require("../img/retina/fullscreenon.svg");
var ___CSS_LOADER_URL_IMPORT_27___ = require("../img/round/left.svg");
var ___CSS_LOADER_URL_IMPORT_28___ = require("../img/round/right.svg");
var ___CSS_LOADER_URL_IMPORT_29___ = require("../img/round/up.svg");
var ___CSS_LOADER_URL_IMPORT_30___ = require("../img/round/down.svg");
var ___CSS_LOADER_URL_IMPORT_31___ = require("../img/round/play.svg");
var ___CSS_LOADER_URL_IMPORT_32___ = require("../img/round/pause.svg");
var ___CSS_LOADER_URL_IMPORT_33___ = require("../img/round/zoomin.svg");
var ___CSS_LOADER_URL_IMPORT_34___ = require("../img/round/zoomout.svg");
var ___CSS_LOADER_URL_IMPORT_35___ = require("../img/round/hotspoton.svg");
var ___CSS_LOADER_URL_IMPORT_36___ = require("../img/round/hotspotoff.svg");
var ___CSS_LOADER_URL_IMPORT_37___ = require("../img/round/fullscreenon.svg");
var ___CSS_LOADER_URL_IMPORT_38___ = require("../img/thin/left.svg");
var ___CSS_LOADER_URL_IMPORT_39___ = require("../img/thin/right.svg");
var ___CSS_LOADER_URL_IMPORT_40___ = require("../img/thin/up.svg");
var ___CSS_LOADER_URL_IMPORT_41___ = require("../img/thin/down.svg");
var ___CSS_LOADER_URL_IMPORT_42___ = require("../img/thin/play.svg");
var ___CSS_LOADER_URL_IMPORT_43___ = require("../img/thin/pause.svg");
var ___CSS_LOADER_URL_IMPORT_44___ = require("../img/thin/zoomin.svg");
var ___CSS_LOADER_URL_IMPORT_45___ = require("../img/thin/zoomout.svg");
var ___CSS_LOADER_URL_IMPORT_46___ = require("../img/thin/hotspoton.svg");
var ___CSS_LOADER_URL_IMPORT_47___ = require("../img/thin/hotspotoff.svg");
var ___CSS_LOADER_URL_IMPORT_48___ = require("../img/thin/fullscreenon.svg");
var ___CSS_LOADER_URL_IMPORT_49___ = require("../img/zoom_dark/fullscreenon.svg");
var ___CSS_LOADER_URL_IMPORT_50___ = require("../img/zoom_light/fullscreenon.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wr360_player
{
    width:100%;
    height:100%;
    background:#fff;
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -khtml-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    -webkit-tap-highlight-color:rgba(0,0,0,0);
    -ms-touch-action:none;
    touch-action:pan-y;
}

.wr360_player .stub_banner_wrap
{
    position:relative;
}

.wr360_player .stub_banner
{
    z-index:1;
    width:100%;
    height:auto;
    animation:stub_banner_fadein 0.3s;
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
}

@keyframes stub_banner_fadein
{
    from
    {
        opacity:0;
    }
    to
    {
        opacity:1;
    }
}

.wr360_player .stub_banner > img
{
    max-width:100% !important;
    max-height:100% !important;
    width:auto;
    height:auto;
    position:absolute;
    top:0;
    bottom:0;
    margin:auto;
    left:0;
    right:0;
}

.wr360_player .container
{
    position:relative;
    overflow:hidden;
    margin:0 !important;
    padding:0 !important;
    border:0 !important;
    box-shadow:none !important;
    background:inherit !important;
    max-width:none !important;
    font-family:Tahoma, sans-serif;
    cursor:pointer !important;
}

.wr360_player .container .progress_pulse
{
    position:absolute;
    width:50px;
    height:50px;
    bottom:0;
    top:0;
    left:0;
    right:0;
    margin:auto;
    background-color:#282828;
    border-radius:100%;
    animation:wr360_popup_wait 0.9s infinite ease-out;
    z-index:1;
    display:none;
    border:1px solid rgba(253,253,253,1);
}

@media (min-width: 200px)
{
    .wr360_player.wr360_player_fs .container .progress_pulse
    {
        width:50px;
        height:50px;
    }
}

@media (min-width: 1200px)
{
    .wr360_player.wr360_player_fs .container .progress_pulse
    {
        width:70px;
        height:70px;
    }
}

.wr360_player .container::before
{
    display:none !important;
}

.wr360_player .container .spinner_hint
{
    width:100%;
    height:100%;
    z-index:11;
    position:absolute;
    left:0;
    top:0;
    display:none;
    cursor:pointer;
}

.wr360_player .container .spinner_hint .spinner_hint_aligner
{
    position:absolute;
    bottom:20px;
    left:0;
    width:100%;
    text-align:center;
    z-index:1;
}

.wr360_player .container .spinner_hint .spinner_hint_item
{
    padding:7px 18px 7px 18px;
    line-height:14px;
    color:#696969;
    font-size:11px;
    background:rgba(240, 240, 240, 0.88);
    border-radius:0;
    margin:0 auto 0 auto;
    max-width:300px;
    font-family:Tahoma,Helvetica,Sans-Serif;
    opacity:0;
    display:inline-block;
    transition:0.2s ease;
}

@-moz-document url-prefix()
{
    .wr360_player .container .spinner_hint .spinner_hint_item
    {
        padding-bottom:8px;
    }
}

.wr360_player .container .spinner_hint:hover .spinner_hint_item
{
    background:rgba(225, 225, 225, 0.78);
    color:#555;
    transition:0.3s ease;
    padding-left:22px;
    padding-right:22px;
}

.wr360_player img
{
    max-width:none !important;
    max-height:none !important;
    border:none !important;
    box-shadow:none !important;
    cursor:pointer !important;
    image-rendering:-webkit-optimize-contrast;
}

.wr360_player .arrow_zoom_cursor,
.wr360_player .arrow_zoom_cursor > img
{
    cursor:url(${___CSS_LOADER_URL_REPLACEMENT_0___}), zoom-in !important;
}

.wr360_player .arrow_zoom_cursor.container_zoomed,
.wr360_player .arrow_zoom_cursor.container_zoomed > img
{
    cursor:url(${___CSS_LOADER_URL_REPLACEMENT_1___}), zoom-out !important;
}

.wr360_player .arrow_zoom_cursor.container_zoomoff,
.wr360_player .arrow_zoom_cursor.container_zoomoff > img
{
    cursor:url(${___CSS_LOADER_URL_REPLACEMENT_2___}), pointer !important;
}

.wr360_player .zoom_cursor,
.wr360_player .zoom_cursor > img
{
    cursor:zoom-in !important;
}

.wr360_player .zoom_cursor.container_zoomed,
.wr360_player .zoom_cursor.container_zoomed > img
{
    cursor:zoom-out !important;
}

.wr360_player .zoom_cursor.container_zoomoff,
.wr360_player .zoom_cursor.container_zoomoff > img
{
    cursor:pointer !important;
}

/* Desktop Safari doesn't work well with -webkit-optimize-contrast so apply this Safari only hack */
@media not all and (min-resolution:.001dpcm)
{
    @media
    {
        .wr360_player img
		{
            image-rendering:auto;
        }
    }
}

.wr360_player .container .panning
{
    position:absolute;
    left:0;
    top:0;
    background-size:100% 100%;
    background-repeat:no-repeat;
    background-position:center;
    z-index:1;
    display:none;
}

.wr360_player .container .theme_header
{
    height:20px;
    z-index:2;
    margin:3px 0 0 0;
    position:absolute;
    top:0;
    left:0;
    width:100%;
    font-family:Tahoma,Helvetica,Sans-Serif;
}

.wr360_player .container .theme_panel
{
    visibility:hidden;
}

.wr360_player .container .theme_header .progress_wrap
{
    float:left;
    cursor:pointer;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs
{
    margin:10px 0 0 15px;
    height:28px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    display:none;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim
{
    margin:1px 0 0 6px;
    height:16px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    display:none;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs div,
.wr360_player .container .theme_header .progress_wrap .progress_bar_anim div
{
    height:100%;
    width:5px;
    opacity:0;
    margin:0 2px 0 0;
    background-color:#bbb;
    float:left;
    overflow:hidden;
    -webkit-animation:wr360_progress_delay 1.2s infinite ease-in-out;
    animation:wr360_progress_delay 1.2s infinite ease-in-out;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs div
{
    width:6px;
    margin:0 3px 0 0;
    background-color:#aaa;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar1,
.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar1
{
    -webkit-animation-delay:-1.2s;
    animation-delay:-1.2s;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar2,
.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar2
{
    -webkit-animation-delay:-1.1s;
    animation-delay:-1.1s;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar3,
.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar3
{
    -webkit-animation-delay:-1.0s;
    animation-delay:-1.0s;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar4,
.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar4
{
    -webkit-animation-delay:-0.9s;
    animation-delay:-0.9s;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar5,
.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar5
{
    -webkit-animation-delay:-0.8s;
    animation-delay:-0.8s;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim span.percentnums
{
    font-size:8px;
    line-height:16px;
    height:16px;
    width:25px;
    float:left;
    color:#999;
    margin:0 0 0 4px;
    display:none;
}

.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums
{
    font-size:11px;
    line-height:28px;
    height:28px;
    width:25px;
    float:left;
    color:#999;
    margin:0 0 0 6px;
    display:none;
}

@media (min-width: 200px)
{
    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs
    {
        margin:5px 0 0 10px;
        height:18px;
    }

    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums
    {
        font-size:9px;
        line-height:18px;
        height:18px;
        margin:0 0 0 5px;
    }
}

@media (min-width: 1200px)
{
    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs
    {
        margin:10px 0 0 15px;
        height:28px;
    }

    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums
    {
        font-size:11px;
        line-height:28px;
        height:28px;
        margin:0 0 0 6px;
    }
}

@-moz-document url-prefix()
{
    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim span.percentnums,
    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums
    {
        margin-top: -1px;
    }
}

@-webkit-keyframes wr360_progress_delay
{
    0%, 40%, 100%
    {
        -webkit-transform:scaleY(0.5);
    }

    20%
	{
        -webkit-transform:scaleY(1.0);
        opacity:1;
    }
}

@keyframes wr360_progress_delay
{
    0%, 40%, 100%
    {
        transform:scaleY(0.5);
        -webkit-transform: scaleY(0.5);
    }
    20%
	{
        transform:scaleY(1.0);
        -webkit-transform: scaleY(1.0);
        opacity:1;
    }
}

.wr360_player .container .theme_header a.watermark
{
    margin:5px 0 0 5px;
    float:left;
    width:1px;
    height:1px;
    cursor:pointer;
    display:none;
}

.wr360_player a.fullscreenoff_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
    width:50px;
    height:50px;
    top:20px;
    right:23px;
    z-index:10;
    position:absolute;
    cursor:pointer;
    display:block;
    transition:none !important;
}

.wr360_player a.fullscreenoff_button:hover
{
	opacity:0.8;
}

.wr360_player .container .hotspot_indicator
{
    z-index:4;
    cursor:pointer;
    background-repeat:no-repeat;
    --anim-duration:2000ms;
    --back-color-hover:auto;
    --back-opacity-hover:auto;
    outline: 1px solid transparent;
}

.wr360_player .container .hotspot_indicator.indicator_dummy
{
    visibility:hidden;
}

.wr360_player .container .clip_indicator.indicator_active,
.wr360_player .container .clip_indicator:hover
{
    background-color:var(--back-color-hover) !important;
    opacity:var(--back-opacity-hover) !important;
    transition:opacity 0.1s ease-out;/*, background-color 0.1s ease-in;*/
}

.wr360_player .container .indicator_effect_flash
{
    animation:wr360_effect_flash var(--anim-duration) ease-out 10ms infinite;
}

.wr360_player .container .indicator_effect_pulseRinged
{
    position:relative;
}

.wr360_player .container .indicator_effect_pulseRinged::after
{
    content:"";
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    border-radius:50%;
    transform-origin:center;
    z-index:1;
    animation:wr360_effect_pulse_ringed var(--anim-duration) ease-out 10ms infinite;
}

.wr360_player .container .indicator_effect_pulseRinged::before
{
    content:"";
    position:absolute;
    top:-1px;
    left:-1px;
    width:100%;
    height:100%;
    border-radius:50%;
    border:1px solid rgba(200, 200, 200, 0);
    transform-origin:center;
    z-index:2;
    animation:wr360_effect_pulse_ringed_border var(--anim-duration) ease-out 10ms infinite;
}

.wr360_player .container .indicator_effect_spin
{
    animation:wr360_effect_spin var(--anim-duration) linear 10ms infinite;
}

.wr360_player .container .indicator_effect_scaleUp
{
    transform:scale(0, 0);
    animation:wr360_effect_scale_up .3s cubic-bezier(.22, .02, .13, .99) forwards;
}

.wr360_player .container .indicator_effect_pulseSimple
{
    animation:wr360_effect_pulse_simple var(--anim-duration) ease-out 10ms infinite;
}

.wr360_player .container .indicator_effect_pulseOuter
{
    border-radius:50%;
    animation:wr360_effect_pulse_outer var(--anim-duration) ease-out 10ms infinite;
}

.wr360_player .container .indicator_effect_pulseRipple
{
    position:relative;
    box-sizing:border-box;
}

.wr360_player .container .indicator_effect_pulseRipple::after,
.wr360_player .container .indicator_effect_pulseRipple::before
{
    content:"";
    position:absolute;
    box-sizing:border-box;
    top:0;
    left:0;
    width:100%;
    height:100%;
    border-radius:50%;
    background:rgba(0,0,0,0);
    border:1px solid #eee;
    transform-origin:center;
    animation:wr360_effect_pulse_ripple var(--anim-duration) linear 10ms infinite;
}

.wr360_player .container .indicator_effect_pulseRipple::before
{
    animation-delay:1s;
}

.wr360_player .container .indicator_effect_pulseDoubleOuter
{
    border-radius:50%;
    animation:wr360_effect_pulse_double_outer var(--anim-duration) ease-out 10ms infinite;
}

.wr360_player .container .hotspot_indicator_hidden
{
    display:none !important;
}

.wr360_player .container .indicator_link_wrap
{
    z-index:3;
    position:absolute;
}

.wr360_player .container .indicator_link
{
    transform-origin:top left;
    position:absolute;
}

.wr360_player .container .position_rollover
{
    position:absolute;
    left:0;
    top:0;
    visibility:hidden;
    z-index:15;
    cursor:pointer;
}

.wr360_player .container .position_rollover > a
{
    display:inline-block;
    box-sizing:border-box;
    text-decoration:none;
}

.wr360_player .container .position_rollover > div
{
    box-sizing:border-box;
}

.wr360_player .container .lightbox_rollover
{
    z-index:18;
    width:100%;
    height:100%;
    background-color:rgba(0, 0, 0, 1);
    position:absolute;
    top:0;
    left:0;
    display:none;
    cursor:default;
}

.wr360_player .container .lightbox_rollover *,
.wr360_player .container .lightbox_rollover2 *
{
    box-sizing:border-box;
}

.wr360_player .container .lightbox_rollover .closelbox
{
    position:absolute;
    background:url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 7px 7px no-repeat;
    right:15px;
    top:15px;
    width:28px;
    height:28px;
    cursor:pointer;
}

.wr360_player .container .lightbox_rollover .closelbox:hover
{
    opacity:0.8;
}

.wr360_player .container .lightbox_rollover .img_wrap
{
    width:100%;
    height:100%;
    max-width:100%;
    max-height:100%;
    background-position:center center;
    background-repeat:no-repeat;
}

.wr360_player .container .lightbox_rollover a.img_wrap
{
    display:block;
}

.wr360_player .container .lightbox_rollover .img_title
{
    position:absolute;
    padding:0;
    max-width:100%;
    width:100%;
    text-align:left;
    bottom:0;
    left:0;
    background-color:rgba(65, 65, 65, 0.9);
}

.wr360_player .container .lightbox_rollover .img_title a
{
    color:#ff0000;
}

.wr360_player .container .lightbox_rollover .img_title .usr_text
{
    display:inline-block;
    color:#fff;
    width:50%;
    text-align:left;
    padding:15px 20px 19px 20px;
    line-height:19px;
    font-size:16px;
}

.wr360_player .container .lightbox_rollover .img_title a.usr_text
{
    display:block;
    text-decoration: none;
}

.wr360_player .container .lightbox_rollover2
{
    position:relative;
    padding:0;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index:18;
    background:transparent;
    display:flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
}

.wr360_player .container .lightbox_rollover2 .lbox2_wrap
{
    width:100%;
    height:100%;
    position:relative;
    cursor:auto;
}

.wr360_player .container .lightbox_rollover2 .closelbox
{
    position:absolute;
    right:7px;
    top:7px;
    width:26px;
    height:26px;
    opacity:1;
    background:none;
    cursor:pointer;
    z-index:2;
}

.wr360_player .container .lightbox_rollover2 .closelbox:hover
{
    opacity:0.7;
}

.wr360_player .container .lightbox_rollover2 .closelbox > div
{
    position:absolute;
    left:calc(50% - 1px);
    height:100%;
    width:2px;
    background-color:#a3a3a3;
}

.wr360_player .container .lightbox_rollover2 .closelbox div:nth-child(1)
{
    transform:rotate(45deg);
}

.wr360_player .container .lightbox_rollover2 .closelbox div:nth-child(2)
{
    transform:rotate(-45deg);
}

.wr360_player .container .lightbox_rollover2 .lbox2_content
{
    width:100%;
    height:100%;
    position:relative;
    z-index:1;
    overflow:auto;
    padding:0 5px 0 5px;
    scrollbar-width:thin;
    scrollbar-color:#b3b3b3 transparent;
    cursor:auto;
}

.wr360_player .container .lightbox_rollover2 .lbox2_content::-webkit-scrollbar
{
    width:6px;
}

.wr360_player .container .lightbox_rollover2 .lbox2_content::-webkit-scrollbar-thumb
{
    background-color:#b3b3b3;
    border-radius:6px;
}

.wr360_player .container .lightbox_rollover2 a.lbox2_content
{
    display:block;
    text-decoration:none;
    color:inherit;
    cursor:pointer;
}

.wr360_player .container .lightbox_rollover2 .lbox2_content.lbox2_frame
{
    overflow:hidden;
    padding:0;
}

.wr360_player .container .lightbox_rollover2 .lbox2_content iframe
{
    width:100%;
    height:100%;
    border:none;
}

.wr360_player .container .lightbox_rollover2 .lbox2_content img
{
    cursor:auto !important;
}

.wr360_player .container .lightbox_rollover2 .lbox2_wait
{
    position:absolute;
    width:50px;
    height:50px;
    bottom:0;
    top:0;
    left:0;
    right:0;
    margin:auto;
    background-color:#999;
    border-radius:100%;
    animation:wr360_popup_wait 0.9s infinite ease-in-out;
    z-index:0;
}

@keyframes wr360_effect_pulse_ringed
{
    0%
    {
        box-shadow:0 0 1px 0 rgba(238, 238, 238, 0);
    }
    50%
    {
        box-shadow:0 0 1px 7px rgba(238, 238, 238, 0.6);
    }
    100%
    {
        box-shadow:0 0 1px 0 rgba(238, 238, 238, 0);
    }
}

@keyframes wr360_effect_pulse_ringed_border
{
    0%
    {
        transform:scale(1);
        border-color:rgba(200, 200, 200, 0);
    }
    50%
    {
        transform:scale(1.46);
        border-color:rgba(200, 200, 200, 0.6);
    }
    100%
    {
        transform:scale(1);
        border-color:rgba(200, 200, 200, 0);
    }
}

@keyframes wr360_effect_spin
{
    100%
    {
        transform:rotate(360deg);
    }
}

@keyframes wr360_effect_scale_up
{
    100%
    {
        transform:scale(1, 1);
    }
}

@keyframes wr360_effect_pulse_simple
{
    0%, 100%
    {
        transform:scale(0.84);
        opacity:0.85;
    }

    50%
    {
        transform:scale(1.0);
        opacity:1;
    }
}

@keyframes wr360_effect_pulse_outer
{
    0%
    {
        box-shadow: 0 0 1px 0 rgba(238, 238, 238, 1), 0 0 0 0 rgba(238, 238, 238, 0);
    }
    100%
    {
        box-shadow:0 0 1px 15px rgba(238, 238, 238, 0), 0 0 0 0 rgba(238, 238, 238, 0.7);
    }
}

@keyframes wr360_effect_pulse_ripple
{
    0%
    {
        transform:scale(1);
        opacity:0.9;
    }
    90%
    {
        transform:scale(2.0);
        opacity:0;
    }
    100%
    {
        transform:scale(1);
        opacity:0;
    }
}

@keyframes wr360_effect_pulse_double_outer
{
    0%
    {
        box-shadow:0 0 0 1px rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0);
    }
    15%
    {
        box-shadow:0 0 0 5px rgba(238, 238, 238, 0.5), 0 0 3px 10px rgba(238, 238, 238, 0.5);
    }
    100%
    {
        box-shadow:0 0 0 4px rgba(0, 0, 0, 0), 0 0 3px 20px rgba(238, 238, 238, 0);
    }
}

@keyframes wr360_popup_wait
{
    0%
    {
        transform:scale(0);
        opacity:1;
        border-color:rgba(253,253,253,1);
    }
    60%
    {
        transform:scale(0.8);
        opacity:0.3;
        border-color:rgba(253,253,253,0.8);
    }
    100%
    {
        transform:scale(1.0);
        opacity:0;
        border-color:rgba(253,253,253,0);
    }
}

@keyframes wr360_effect_flash
{
    75%
    {
        opacity:1;
    }
    90%
    {
        opacity:0.1;
    }
}

/* Skins */

/* Basic */

.wr360_player.basic .container .theme_panel_back
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:34px;
    z-index:2;
}

.wr360_player.basic .container .theme_panel
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:34px;
    z-index:3;
    cursor:pointer !important;
}

.wr360_player.basic .container .theme_panel .toolbar
{
    position:relative;
    height:34px;
    padding:0 10px 0 10px;
    margin:0 auto 0 auto;
    box-sizing:content-box !important;
    border:none !important;
    background:inherit !important;
    pointer-events:none;
}

.wr360_player.basic .container .theme_panel .toolbar > a
{
    transition:none !important;
    display:block;
    float:left;
    width:22px;
    height:24px;
    margin:5px 0 0 11px;
	opacity:0.7;
}

.wr360_player.basic .container .theme_panel .toolbar > a:first-of-type
{
    margin-left:0;
}

.wr360_player.basic .container .theme_panel .toolbar a.left_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat 0 0;
}

.wr360_player.basic .container .theme_panel .toolbar a.right_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 0 0;
    margin-right:2px;
}

.wr360_player.basic .container .theme_panel .toolbar a.up_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat 0 0;
    margin-left:10px;
}

.wr360_player.basic .container .theme_panel .toolbar a.down_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat 0 0;
    margin-left:7px;
}

.wr360_player.basic .container .theme_panel .toolbar a.play_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat 0 0;
}

.wr360_player.basic .container .theme_panel .toolbar a.pause_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat 0 0;
}

.wr360_player.basic .container .theme_panel .toolbar a.zoomin_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 0 0;
}

.wr360_player.basic .container_zoomoff .theme_panel .toolbar a.zoomin_button,
.wr360_player.basic .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover
{
    cursor:default;
    opacity:0.4;
}

.wr360_player.basic .container .theme_panel .toolbar a.zoomout_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 0 0;
}

.wr360_player.basic .container .theme_panel .toolbar a.hotspotson_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat 0 0;
    margin-left:8px;
}

.wr360_player.basic .container .theme_panel .toolbar a.hotspotsoff_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat 0 0;
    margin-left:8px;
}

.wr360_player.basic .container .theme_panel .toolbar a.fullscreenon_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat 0 0;
}

.wr360_player.basic .container .theme_panel .toolbar > a:hover
{
	opacity:0.6;
}

/* Empty */

.wr360_player.empty .container .theme_panel_back
{
    position:absolute;
    width:0 !important;
    bottom:0 !important;
    left:0 !important;
    margin:0 !important;
    height:0 !important;
    z-index:0 !important;
}

.wr360_player.empty .container .theme_panel
{
    position:absolute;
    width:0 !important;
    bottom:0 !important;
    left:0 !important;
    margin:0 !important;
    height:0 !important;
    z-index:0 !important;
    cursor:pointer !important;
}

.wr360_player.empty .container .theme_panel .toolbar
{
    position:relative;
    height:0 !important;
    padding:0 !important;
    margin:0 !important;
    pointer-events:none;
}

.wr360_player.empty .container .theme_panel .toolbar a.fullscreenoff_button,
.wr360_player.empty .container .theme_panel .toolbar a.fullscreenon_button,
.wr360_player.empty .container .theme_panel .toolbar a.hotspotsoff_button,
.wr360_player.empty .container .theme_panel .toolbar a.hotspotson_button,
.wr360_player.empty .container .theme_panel .toolbar a.zoomout_button,
.wr360_player.empty .container .theme_panel .toolbar a.zoomin_button,
.wr360_player.empty .container .theme_panel .toolbar a.right_button,
.wr360_player.empty .container .theme_panel .toolbar a.pause_button,
.wr360_player.empty .container .theme_panel .toolbar a.play_button,
.wr360_player.empty .container .theme_panel .toolbar a.left_button,
.wr360_player.empty .container .theme_panel .toolbar a.down_button,
.wr360_player.empty .container .theme_panel .toolbar a.up_button
{
    background:none !important;
    display:none !important;
    width:0 !important;
    height:0 !important;
    margin:0 !important;
}

/* Retina */

.wr360_player.retina .container .theme_panel_back
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:50px;
    z-index:2;
}

.wr360_player.retina .container .theme_panel
{
    position:absolute;
    width:100%;
    bottom:0px;
    left:0;
    height:50px;
    z-index:3;
    cursor:pointer !important;
}

.wr360_player.retina .container .theme_panel .toolbar
{
    position:relative;
    height:42px;
    padding:3px 10px 0 10px;
    margin:0 auto 0 auto;
    box-sizing:content-box !important;
    border:none !important;
    background:inherit !important;
    pointer-events:none;
}

.wr360_player.retina .container .theme_panel .toolbar > a
{
    transition:none !important;
    display:block;
    float:left;
    width:38px;
    height:38px;
    margin:3px 0 0 11px;
}

.wr360_player.retina .container .theme_panel .toolbar > a:first-of-type
{
    margin-left:0;
}

.wr360_player.retina .container .theme_panel .toolbar a.left_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.right_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.up_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.down_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.play_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.pause_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.zoomin_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat 0 0;
}

.wr360_player.retina .container_zoomoff .theme_panel .toolbar a.zoomin_button,
.wr360_player.retina .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover
{
    cursor:default;
    opacity:0.4;
}

.wr360_player.retina .container .theme_panel .toolbar a.zoomout_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_23___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.hotspotson_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.hotspotsoff_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar a.fullscreenon_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat 0 0;
}

.wr360_player.retina .container .theme_panel .toolbar > a:hover
{
	opacity:0.8;
}

/* Round */

.wr360_player.round .container .theme_panel_back
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:38px;
    z-index:2;
}

.wr360_player.round .container .theme_panel
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:38px;
    z-index:3;
    cursor:pointer !important;
}

.wr360_player.round .container .theme_panel .toolbar
{
    position:relative;
    height:29px;
    padding:3px 10px 0 10px;
    margin:0 auto 0 auto;
    box-sizing:content-box !important;
    border:none !important;
    background:inherit !important;
    pointer-events:none;
}

.wr360_player.round .container .theme_panel .toolbar > a
{
    transition:none !important;
    display:block;
    float:left;
    width:28px;
    height:28px;
    margin:2px 0 0 8px;
    opacity:1;
}

.wr360_player.round .container .theme_panel .toolbar > a:first-of-type
{
    margin-left:0;
}

.wr360_player.round .container .theme_panel .toolbar a.left_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.right_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.up_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_29___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.down_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.play_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_31___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.pause_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_32___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.zoomin_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat 0 0;
}

.wr360_player.round .container_zoomoff .theme_panel .toolbar a.zoomin_button,
.wr360_player.round .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover
{
    cursor:default;
    opacity:0.4;
}

.wr360_player.round .container .theme_panel .toolbar a.zoomout_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_34___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.hotspotson_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_35___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.hotspotsoff_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_36___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar a.fullscreenon_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat 0 0;
}

.wr360_player.round .container .theme_panel .toolbar > a:hover
{
	opacity:0.8;
}

/* Thin */

.wr360_player.thin .container .theme_panel_back
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:28px;
    z-index:2;
}

.wr360_player.thin .container .theme_panel
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:28px;
    z-index:3;
    cursor:pointer !important;
}

.wr360_player.thin .container .theme_panel .toolbar
{
    position:relative;
    height:28px;
    padding:1px 10px 0 10px;
    margin:0 auto 0 auto;
    box-sizing:content-box !important;
    border:none !important;
    background:inherit !important;
    pointer-events:none;
}

.wr360_player.thin .container .theme_panel .toolbar > a
{
    transition:none !important;
    display:block;
    float:left;
    width:18px;
    height:18px;
    margin:4px 0 0 12px;
    opacity:1;
}

.wr360_player.thin .container .theme_panel .toolbar > a:first-of-type
{
    margin-left:0;
}

.wr360_player.thin .container .theme_panel .toolbar a.left_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_38___}) no-repeat 0 0;
    margin-right:-2px;
}

.wr360_player.thin .container .theme_panel .toolbar a.right_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_39___}) no-repeat 0 0;
    margin-right:-1px;
}

.wr360_player.thin .container .theme_panel .toolbar a.up_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_40___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar a.down_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_41___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar a.play_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_42___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar a.pause_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_43___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar a.zoomin_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_44___}) no-repeat 0 0;
}

.wr360_player.thin .container_zoomoff .theme_panel .toolbar a.zoomin_button,
.wr360_player.thin .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover
{
    cursor:default;
    opacity:0.4;
}

.wr360_player.thin .container .theme_panel .toolbar a.zoomout_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_45___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar a.hotspotson_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_46___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar a.hotspotsoff_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_47___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar a.fullscreenon_button
{
    background:url(${___CSS_LOADER_URL_REPLACEMENT_48___}) no-repeat 0 0;
}

.wr360_player.thin .container .theme_panel .toolbar > a:hover
{
	opacity:0.8;
}

/* Zoom Dark */

.wr360_player.zoom_dark .container .theme_panel_back
{
	display:none;
}

.wr360_player.zoom_dark .container .theme_panel
{
    position:absolute;
    width:100%;
    bottom:0;
    left:0;
    height:66px;
    z-index:3;
	pointer-events:none;
}

.wr360_player.zoom_dark .container .theme_panel .toolbar
{
    position:relative;
    padding:0 15px 0 15px;
    margin:15px auto 0 auto;
    box-sizing:content-box !important;
    border:none !important;
    background:inherit !important;
    pointer-events:none;
}

.wr360_player.zoom_dark .container .theme_panel .toolbar > a
{
    width:0;
	height:0;
	display:none !important;
    transition:none !important;
}

.wr360_player.zoom_dark .container .theme_panel .toolbar a.fullscreenon_button
{
	width:36px;
	height:36px;
    background:url(${___CSS_LOADER_URL_REPLACEMENT_49___}) no-repeat center center;
	background-size:36px 36px;
	background-color:rgba(40,40,40,0.8);
	display:block !important;
	cursor:pointer;
	pointer-events:auto;
}

/*
.wr360_player.wr360_player_fs .container .theme_panel .toolbar a.fullscreenon_button
{
    display:none !important;
}*/

.wr360_player.zoom_dark .container .theme_panel .toolbar > a:hover
{
	opacity:0.8;
}

/* Zoom Light */

.wr360_player.zoom_light .container .theme_panel_back
{
	display:none;
}

.wr360_player.zoom_light .container .theme_panel
{
    position:absolute;
    width:100%;
    bottom:0px;
    left:0;
    height:66px;
    z-index:3;
    pointer-events:none;
}

.wr360_player.zoom_light .container .theme_panel .toolbar
{
    position:relative;
    padding:0 15px 0 15px;
    margin:15px auto 0 auto;
    box-sizing:content-box !important;
    border:none !important;
    background:inherit !important;
    pointer-events:none;
}

.wr360_player.zoom_light .container .theme_panel .toolbar > a
{
    width:0;
	height:0;
    display:none !important;
    transition:none !important;
}

.wr360_player.zoom_light .container .theme_panel .toolbar a.fullscreenon_button
{
	width:36px;
	height:36px;
    background:url(${___CSS_LOADER_URL_REPLACEMENT_50___}) no-repeat 0 0;
	background-size:36px 36px;
	background-color:rgba(248,248,248,0.8);
    display:block !important;
    cursor:pointer;
    pointer-events:auto;
}

/*
.wr360_player.wr360_player_fs .container .theme_panel .toolbar a.fullscreenon_button
{
    display:none !important;
}*/

.wr360_player.zoom_light .container .theme_panel .toolbar > a:hover
{
	opacity:0.8;
}

`, "",{"version":3,"sources":["webpack://./node_modules/@webrotate360/imagerotator/build/css/all.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,wBAAwB;IACxB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,yCAAyC;IACzC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,iBAAiB;IACjB,KAAK;IACL,QAAQ;IACR,MAAM;IACN,OAAO;AACX;;AAEA;;IAEI;;QAEI,SAAS;IACb;IACA;;QAEI,SAAS;IACb;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;IAC1B,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,KAAK;IACL,QAAQ;IACR,WAAW;IACX,MAAM;IACN,OAAO;AACX;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,KAAK;IACL,MAAM;IACN,OAAO;IACP,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,iDAAiD;IACjD,SAAS;IACT,YAAY;IACZ,oCAAoC;AACxC;;AAEA;;IAEI;;QAEI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,MAAM;IACN,KAAK;IACL,YAAY;IACZ,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,MAAM;IACN,UAAU;IACV,iBAAiB;IACjB,SAAS;AACb;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,uCAAuC;IACvC,SAAS;IACT,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;;IAEI;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;;IAEI,oCAAoC;IACpC,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;;;IAGI,kEAA8D;AAClE;;AAEA;;;IAGI,mEAAgE;AACpE;;AAEA;;;IAGI,kEAA+D;AACnE;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAGI,0BAA0B;AAC9B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA,mGAAmG;AACnG;;IAEI;;QAEI;;YAEI,oBAAoB;QACxB;IACJ;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,MAAM;IACN,KAAK;IACL,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,UAAU;IACV,uCAAuC;AAC3C;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;IACV,cAAc;AAClB;;AAEA;;IAEI,oBAAoB;IACpB,WAAW;IACX,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,eAAe;IACf,gEAAgE;IAChE,wDAAwD;AAC5D;;AAEA;;IAEI,SAAS;IACT,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;;IAGI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;;IAGI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;;IAGI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;;IAGI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;;IAGI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI;;QAEI,mBAAmB;QACnB,WAAW;IACf;;IAEA;;QAEI,aAAa;QACb,gBAAgB;QAChB,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;QAEI,oBAAoB;QACpB,WAAW;IACf;;IAEA;;QAEI,cAAc;QACd,gBAAgB;QAChB,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;;QAGI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,6BAA6B;QAC7B,SAAS;IACb;AACJ;;AAEA;;IAEI;;QAEI,qBAAqB;QACrB,8BAA8B;IAClC;IACA;;QAEI,qBAAqB;QACrB,8BAA8B;QAC9B,SAAS;IACb;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,0EAAoE;IACpE,UAAU;IACV,WAAW;IACX,QAAQ;IACR,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,0BAA0B;AAC9B;;AAEA;;CAEC,WAAW;AACZ;;AAEA;;IAEI,SAAS;IACT,cAAc;IACd,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;;IAGI,mDAAmD;IACnD,4CAA4C;IAC5C,gCAAgC,CAAC,mCAAmC;AACxE;;AAEA;;IAEI,wEAAwE;AAC5E;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;IACV,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,+EAA+E;AACnF;;AAEA;;IAEI,UAAU;IACV,iBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,uCAAuC;IACvC,uBAAuB;IACvB,SAAS;IACT,sFAAsF;AAC1F;;AAEA;;IAEI,qEAAqE;AACzE;;AAEA;;IAEI,qBAAqB;IACrB,6EAA6E;AACjF;;AAEA;;IAEI,+EAA+E;AACnF;;AAEA;;IAEI,iBAAiB;IACjB,8EAA8E;AAClF;;AAEA;;IAEI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,UAAU;IACV,iBAAiB;IACjB,qBAAqB;IACrB,KAAK;IACL,MAAM;IACN,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,6EAA6E;AACjF;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,qFAAqF;AACzF;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,SAAS;IACT,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,MAAM;IACN,KAAK;IACL,iBAAiB;IACjB,UAAU;IACV,cAAc;AAClB;;AAEA;;IAEI,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,UAAU;IACV,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,YAAY;IACZ,cAAc;AAClB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;IACjB,oEAA+D;IAC/D,UAAU;IACV,QAAQ;IACR,UAAU;IACV,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;IACf,QAAQ;IACR,MAAM;IACN,sCAAsC;AAC1C;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,oBAAoB;IACpB,UAAU;IACV,SAAS;IACT,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,WAAW;IACX,KAAK;IACL,MAAM;IACN,UAAU;IACV,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,SAAS;IACT,OAAO;IACP,UAAU;IACV,WAAW;IACX,SAAS;IACT,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,SAAS;IACT,wBAAwB;AAC5B;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mCAAmC;IACnC,WAAW;AACf;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,SAAS;AACb;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,WAAW;AACf;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,KAAK;IACL,MAAM;IACN,OAAO;IACP,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,oDAAoD;IACpD,SAAS;AACb;;AAEA;;IAEI;;QAEI,2CAA2C;IAC/C;IACA;;QAEI,+CAA+C;IACnD;IACA;;QAEI,2CAA2C;IAC/C;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,mCAAmC;IACvC;IACA;;QAEI,qBAAqB;QACrB,qCAAqC;IACzC;IACA;;QAEI,kBAAkB;QAClB,mCAAmC;IACvC;AACJ;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;;QAEI,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;;QAEI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;;QAEI,oBAAoB;QACpB,SAAS;IACb;AACJ;;AAEA;;IAEI;;QAEI,4EAA4E;IAChF;IACA;;QAEI,gFAAgF;IACpF;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,WAAW;IACf;IACA;;QAEI,oBAAoB;QACpB,SAAS;IACb;IACA;;QAEI,kBAAkB;QAClB,SAAS;IACb;AACJ;;AAEA;;IAEI;;QAEI,+DAA+D;IACnE;IACA;;QAEI,oFAAoF;IACxF;IACA;;QAEI,0EAA0E;IAC9E;AACJ;;AAEA;;IAEI;;QAEI,kBAAkB;QAClB,SAAS;QACT,gCAAgC;IACpC;IACA;;QAEI,oBAAoB;QACpB,WAAW;QACX,kCAAkC;IACtC;IACA;;QAEI,oBAAoB;QACpB,SAAS;QACT,gCAAgC;IACpC;AACJ;;AAEA;;IAEI;;QAEI,SAAS;IACb;IACA;;QAEI,WAAW;IACf;AACJ;;AAEA,UAAU;;AAEV,UAAU;;AAEV;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;IACX,mBAAmB;CACtB,WAAW;AACZ;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,gEAAmD;AACvD;;AAEA;;IAEI,gEAAoD;IACpD,gBAAgB;AACpB;;AAEA;;IAEI,gEAAiD;IACjD,gBAAgB;AACpB;;AAEA;;IAEI,gEAAmD;IACnD,eAAe;AACnB;;AAEA;;IAEI,gEAAmD;AACvD;;AAEA;;IAEI,iEAAoD;AACxD;;AAEA;;IAEI,iEAAqD;AACzD;;AAEA;;;IAGI,cAAc;IACd,WAAW;AACf;;AAEA;;IAEI,iEAAsD;AAC1D;;AAEA;;IAEI,iEAAwD;IACxD,eAAe;AACnB;;AAEA;;IAEI,iEAAyD;IACzD,eAAe;AACnB;;AAEA;;IAEI,iEAA2D;AAC/D;;AAEA;;CAEC,WAAW;AACZ;;AAEA,UAAU;;AAEV;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;IAaI,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,WAAW;;AAEX;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,MAAM;IACN,WAAW;IACX,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iEAAoD;AACxD;;AAEA;;IAEI,iEAAqD;AACzD;;AAEA;;IAEI,iEAAkD;AACtD;;AAEA;;IAEI,iEAAoD;AACxD;;AAEA;;IAEI,iEAAoD;AACxD;;AAEA;;IAEI,iEAAqD;AACzD;;AAEA;;IAEI,iEAAsD;AAC1D;;AAEA;;;IAGI,cAAc;IACd,WAAW;AACf;;AAEA;;IAEI,iEAAuD;AAC3D;;AAEA;;IAEI,iEAAyD;AAC7D;;AAEA;;IAEI,iEAA0D;AAC9D;;AAEA;;IAEI,iEAA4D;AAChE;;AAEA;;CAEC,WAAW;AACZ;;AAEA,UAAU;;AAEV;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iEAAmD;AACvD;;AAEA;;IAEI,iEAAoD;AACxD;;AAEA;;IAEI,iEAAiD;AACrD;;AAEA;;IAEI,iEAAmD;AACvD;;AAEA;;IAEI,iEAAmD;AACvD;;AAEA;;IAEI,iEAAoD;AACxD;;AAEA;;IAEI,iEAAqD;AACzD;;AAEA;;;IAGI,cAAc;IACd,WAAW;AACf;;AAEA;;IAEI,iEAAsD;AAC1D;;AAEA;;IAEI,iEAAwD;AAC5D;;AAEA;;IAEI,iEAAyD;AAC7D;;AAEA;;IAEI,iEAA2D;AAC/D;;AAEA;;CAEC,WAAW;AACZ;;AAEA,SAAS;;AAET;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iEAAkD;IAClD,iBAAiB;AACrB;;AAEA;;IAEI,iEAAmD;IACnD,iBAAiB;AACrB;;AAEA;;IAEI,iEAAgD;AACpD;;AAEA;;IAEI,iEAAkD;AACtD;;AAEA;;IAEI,iEAAkD;AACtD;;AAEA;;IAEI,iEAAmD;AACvD;;AAEA;;IAEI,iEAAoD;AACxD;;AAEA;;;IAGI,cAAc;IACd,WAAW;AACf;;AAEA;;IAEI,iEAAqD;AACzD;;AAEA;;IAEI,iEAAuD;AAC3D;;AAEA;;IAEI,iEAAwD;AAC5D;;AAEA;;IAEI,iEAA0D;AAC9D;;AAEA;;CAEC,WAAW;AACZ;;AAEA,cAAc;;AAEd;;CAEC,YAAY;AACb;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;CACZ,mBAAmB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,OAAO;CACV,QAAQ;CACR,uBAAuB;IACpB,0BAA0B;AAC9B;;AAEA;;CAEC,UAAU;CACV,WAAW;IACR,2EAAyE;CAC5E,yBAAyB;CACzB,mCAAmC;CACnC,wBAAwB;CACxB,cAAc;CACd,mBAAmB;AACpB;;AAEA;;;;EAIE;;AAEF;;CAEC,WAAW;AACZ;;AAEA,eAAe;;AAEf;;CAEC,YAAY;AACb;;AAEA;;IAEI,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,MAAM;IACN,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,iCAAiC;IACjC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,OAAO;CACV,QAAQ;IACL,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;;CAEC,UAAU;CACV,WAAW;IACR,iEAAgE;CACnE,yBAAyB;CACzB,sCAAsC;IACnC,wBAAwB;IACxB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;;EAIE;;AAEF;;CAEC,WAAW;AACZ","sourcesContent":[".wr360_player\r\n{\r\n    width:100%;\r\n    height:100%;\r\n    background:#fff;\r\n    -webkit-touch-callout:none;\r\n    -webkit-user-select:none;\r\n    -khtml-user-select:none;\r\n    -moz-user-select:none;\r\n    -ms-user-select:none;\r\n    user-select:none;\r\n    -webkit-tap-highlight-color:rgba(0,0,0,0);\r\n    -ms-touch-action:none;\r\n    touch-action:pan-y;\r\n}\r\n\r\n.wr360_player .stub_banner_wrap\r\n{\r\n    position:relative;\r\n}\r\n\r\n.wr360_player .stub_banner\r\n{\r\n    z-index:1;\r\n    width:100%;\r\n    height:auto;\r\n    animation:stub_banner_fadein 0.3s;\r\n    position:absolute;\r\n    top:0;\r\n    bottom:0;\r\n    left:0;\r\n    right:0;\r\n}\r\n\r\n@keyframes stub_banner_fadein\r\n{\r\n    from\r\n    {\r\n        opacity:0;\r\n    }\r\n    to\r\n    {\r\n        opacity:1;\r\n    }\r\n}\r\n\r\n.wr360_player .stub_banner > img\r\n{\r\n    max-width:100% !important;\r\n    max-height:100% !important;\r\n    width:auto;\r\n    height:auto;\r\n    position:absolute;\r\n    top:0;\r\n    bottom:0;\r\n    margin:auto;\r\n    left:0;\r\n    right:0;\r\n}\r\n\r\n.wr360_player .container\r\n{\r\n    position:relative;\r\n    overflow:hidden;\r\n    margin:0 !important;\r\n    padding:0 !important;\r\n    border:0 !important;\r\n    box-shadow:none !important;\r\n    background:inherit !important;\r\n    max-width:none !important;\r\n    font-family:Tahoma, sans-serif;\r\n    cursor:pointer !important;\r\n}\r\n\r\n.wr360_player .container .progress_pulse\r\n{\r\n    position:absolute;\r\n    width:50px;\r\n    height:50px;\r\n    bottom:0;\r\n    top:0;\r\n    left:0;\r\n    right:0;\r\n    margin:auto;\r\n    background-color:#282828;\r\n    border-radius:100%;\r\n    animation:wr360_popup_wait 0.9s infinite ease-out;\r\n    z-index:1;\r\n    display:none;\r\n    border:1px solid rgba(253,253,253,1);\r\n}\r\n\r\n@media (min-width: 200px)\r\n{\r\n    .wr360_player.wr360_player_fs .container .progress_pulse\r\n    {\r\n        width:50px;\r\n        height:50px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px)\r\n{\r\n    .wr360_player.wr360_player_fs .container .progress_pulse\r\n    {\r\n        width:70px;\r\n        height:70px;\r\n    }\r\n}\r\n\r\n.wr360_player .container::before\r\n{\r\n    display:none !important;\r\n}\r\n\r\n.wr360_player .container .spinner_hint\r\n{\r\n    width:100%;\r\n    height:100%;\r\n    z-index:11;\r\n    position:absolute;\r\n    left:0;\r\n    top:0;\r\n    display:none;\r\n    cursor:pointer;\r\n}\r\n\r\n.wr360_player .container .spinner_hint .spinner_hint_aligner\r\n{\r\n    position:absolute;\r\n    bottom:20px;\r\n    left:0;\r\n    width:100%;\r\n    text-align:center;\r\n    z-index:1;\r\n}\r\n\r\n.wr360_player .container .spinner_hint .spinner_hint_item\r\n{\r\n    padding:7px 18px 7px 18px;\r\n    line-height:14px;\r\n    color:#696969;\r\n    font-size:11px;\r\n    background:rgba(240, 240, 240, 0.88);\r\n    border-radius:0;\r\n    margin:0 auto 0 auto;\r\n    max-width:300px;\r\n    font-family:Tahoma,Helvetica,Sans-Serif;\r\n    opacity:0;\r\n    display:inline-block;\r\n    transition:0.2s ease;\r\n}\r\n\r\n@-moz-document url-prefix()\r\n{\r\n    .wr360_player .container .spinner_hint .spinner_hint_item\r\n    {\r\n        padding-bottom:8px;\r\n    }\r\n}\r\n\r\n.wr360_player .container .spinner_hint:hover .spinner_hint_item\r\n{\r\n    background:rgba(225, 225, 225, 0.78);\r\n    color:#555;\r\n    transition:0.3s ease;\r\n    padding-left:22px;\r\n    padding-right:22px;\r\n}\r\n\r\n.wr360_player img\r\n{\r\n    max-width:none !important;\r\n    max-height:none !important;\r\n    border:none !important;\r\n    box-shadow:none !important;\r\n    cursor:pointer !important;\r\n    image-rendering:-webkit-optimize-contrast;\r\n}\r\n\r\n.wr360_player .arrow_zoom_cursor,\r\n.wr360_player .arrow_zoom_cursor > img\r\n{\r\n    cursor:url(../img/all/pointer-zoom-in.svg), zoom-in !important;\r\n}\r\n\r\n.wr360_player .arrow_zoom_cursor.container_zoomed,\r\n.wr360_player .arrow_zoom_cursor.container_zoomed > img\r\n{\r\n    cursor:url(../img/all/pointer-zoom-out.svg), zoom-out !important;\r\n}\r\n\r\n.wr360_player .arrow_zoom_cursor.container_zoomoff,\r\n.wr360_player .arrow_zoom_cursor.container_zoomoff > img\r\n{\r\n    cursor:url(../img/all/pointer-zoom-off.svg), pointer !important;\r\n}\r\n\r\n.wr360_player .zoom_cursor,\r\n.wr360_player .zoom_cursor > img\r\n{\r\n    cursor:zoom-in !important;\r\n}\r\n\r\n.wr360_player .zoom_cursor.container_zoomed,\r\n.wr360_player .zoom_cursor.container_zoomed > img\r\n{\r\n    cursor:zoom-out !important;\r\n}\r\n\r\n.wr360_player .zoom_cursor.container_zoomoff,\r\n.wr360_player .zoom_cursor.container_zoomoff > img\r\n{\r\n    cursor:pointer !important;\r\n}\r\n\r\n/* Desktop Safari doesn't work well with -webkit-optimize-contrast so apply this Safari only hack */\r\n@media not all and (min-resolution:.001dpcm)\r\n{\r\n    @media\r\n    {\r\n        .wr360_player img\r\n\t\t{\r\n            image-rendering:auto;\r\n        }\r\n    }\r\n}\r\n\r\n.wr360_player .container .panning\r\n{\r\n    position:absolute;\r\n    left:0;\r\n    top:0;\r\n    background-size:100% 100%;\r\n    background-repeat:no-repeat;\r\n    background-position:center;\r\n    z-index:1;\r\n    display:none;\r\n}\r\n\r\n.wr360_player .container .theme_header\r\n{\r\n    height:20px;\r\n    z-index:2;\r\n    margin:3px 0 0 0;\r\n    position:absolute;\r\n    top:0;\r\n    left:0;\r\n    width:100%;\r\n    font-family:Tahoma,Helvetica,Sans-Serif;\r\n}\r\n\r\n.wr360_player .container .theme_panel\r\n{\r\n    visibility:hidden;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap\r\n{\r\n    float:left;\r\n    cursor:pointer;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs\r\n{\r\n    margin:10px 0 0 15px;\r\n    height:28px;\r\n    -webkit-user-select:none;\r\n    -moz-user-select:none;\r\n    -ms-user-select:none;\r\n    user-select:none;\r\n    display:none;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim\r\n{\r\n    margin:1px 0 0 6px;\r\n    height:16px;\r\n    -webkit-user-select:none;\r\n    -moz-user-select:none;\r\n    -ms-user-select:none;\r\n    user-select:none;\r\n    display:none;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs div,\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim div\r\n{\r\n    height:100%;\r\n    width:5px;\r\n    opacity:0;\r\n    margin:0 2px 0 0;\r\n    background-color:#bbb;\r\n    float:left;\r\n    overflow:hidden;\r\n    -webkit-animation:wr360_progress_delay 1.2s infinite ease-in-out;\r\n    animation:wr360_progress_delay 1.2s infinite ease-in-out;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs div\r\n{\r\n    width:6px;\r\n    margin:0 3px 0 0;\r\n    background-color:#aaa;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar1,\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar1\r\n{\r\n    -webkit-animation-delay:-1.2s;\r\n    animation-delay:-1.2s;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar2,\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar2\r\n{\r\n    -webkit-animation-delay:-1.1s;\r\n    animation-delay:-1.1s;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar3,\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar3\r\n{\r\n    -webkit-animation-delay:-1.0s;\r\n    animation-delay:-1.0s;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar4,\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar4\r\n{\r\n    -webkit-animation-delay:-0.9s;\r\n    animation-delay:-0.9s;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim .animbar5,\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs .animbar5\r\n{\r\n    -webkit-animation-delay:-0.8s;\r\n    animation-delay:-0.8s;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim span.percentnums\r\n{\r\n    font-size:8px;\r\n    line-height:16px;\r\n    height:16px;\r\n    width:25px;\r\n    float:left;\r\n    color:#999;\r\n    margin:0 0 0 4px;\r\n    display:none;\r\n}\r\n\r\n.wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums\r\n{\r\n    font-size:11px;\r\n    line-height:28px;\r\n    height:28px;\r\n    width:25px;\r\n    float:left;\r\n    color:#999;\r\n    margin:0 0 0 6px;\r\n    display:none;\r\n}\r\n\r\n@media (min-width: 200px)\r\n{\r\n    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs\r\n    {\r\n        margin:5px 0 0 10px;\r\n        height:18px;\r\n    }\r\n\r\n    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums\r\n    {\r\n        font-size:9px;\r\n        line-height:18px;\r\n        height:18px;\r\n        margin:0 0 0 5px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px)\r\n{\r\n    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs\r\n    {\r\n        margin:10px 0 0 15px;\r\n        height:28px;\r\n    }\r\n\r\n    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums\r\n    {\r\n        font-size:11px;\r\n        line-height:28px;\r\n        height:28px;\r\n        margin:0 0 0 6px;\r\n    }\r\n}\r\n\r\n@-moz-document url-prefix()\r\n{\r\n    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim span.percentnums,\r\n    .wr360_player .container .theme_header .progress_wrap .progress_bar_anim_fs span.percentnums\r\n    {\r\n        margin-top: -1px;\r\n    }\r\n}\r\n\r\n@-webkit-keyframes wr360_progress_delay\r\n{\r\n    0%, 40%, 100%\r\n    {\r\n        -webkit-transform:scaleY(0.5);\r\n    }\r\n\r\n    20%\r\n\t{\r\n        -webkit-transform:scaleY(1.0);\r\n        opacity:1;\r\n    }\r\n}\r\n\r\n@keyframes wr360_progress_delay\r\n{\r\n    0%, 40%, 100%\r\n    {\r\n        transform:scaleY(0.5);\r\n        -webkit-transform: scaleY(0.5);\r\n    }\r\n    20%\r\n\t{\r\n        transform:scaleY(1.0);\r\n        -webkit-transform: scaleY(1.0);\r\n        opacity:1;\r\n    }\r\n}\r\n\r\n.wr360_player .container .theme_header a.watermark\r\n{\r\n    margin:5px 0 0 5px;\r\n    float:left;\r\n    width:1px;\r\n    height:1px;\r\n    cursor:pointer;\r\n    display:none;\r\n}\r\n\r\n.wr360_player a.fullscreenoff_button\r\n{\r\n    background:url(../img/all/fullscreenoff.svg) no-repeat center center;\r\n    width:50px;\r\n    height:50px;\r\n    top:20px;\r\n    right:23px;\r\n    z-index:10;\r\n    position:absolute;\r\n    cursor:pointer;\r\n    display:block;\r\n    transition:none !important;\r\n}\r\n\r\n.wr360_player a.fullscreenoff_button:hover\r\n{\r\n\topacity:0.8;\r\n}\r\n\r\n.wr360_player .container .hotspot_indicator\r\n{\r\n    z-index:4;\r\n    cursor:pointer;\r\n    background-repeat:no-repeat;\r\n    --anim-duration:2000ms;\r\n    --back-color-hover:auto;\r\n    --back-opacity-hover:auto;\r\n    outline: 1px solid transparent;\r\n}\r\n\r\n.wr360_player .container .hotspot_indicator.indicator_dummy\r\n{\r\n    visibility:hidden;\r\n}\r\n\r\n.wr360_player .container .clip_indicator.indicator_active,\r\n.wr360_player .container .clip_indicator:hover\r\n{\r\n    background-color:var(--back-color-hover) !important;\r\n    opacity:var(--back-opacity-hover) !important;\r\n    transition:opacity 0.1s ease-out;/*, background-color 0.1s ease-in;*/\r\n}\r\n\r\n.wr360_player .container .indicator_effect_flash\r\n{\r\n    animation:wr360_effect_flash var(--anim-duration) ease-out 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseRinged\r\n{\r\n    position:relative;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseRinged::after\r\n{\r\n    content:\"\";\r\n    position:absolute;\r\n    top:0;\r\n    left:0;\r\n    width:100%;\r\n    height:100%;\r\n    border-radius:50%;\r\n    transform-origin:center;\r\n    z-index:1;\r\n    animation:wr360_effect_pulse_ringed var(--anim-duration) ease-out 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseRinged::before\r\n{\r\n    content:\"\";\r\n    position:absolute;\r\n    top:-1px;\r\n    left:-1px;\r\n    width:100%;\r\n    height:100%;\r\n    border-radius:50%;\r\n    border:1px solid rgba(200, 200, 200, 0);\r\n    transform-origin:center;\r\n    z-index:2;\r\n    animation:wr360_effect_pulse_ringed_border var(--anim-duration) ease-out 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_spin\r\n{\r\n    animation:wr360_effect_spin var(--anim-duration) linear 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_scaleUp\r\n{\r\n    transform:scale(0, 0);\r\n    animation:wr360_effect_scale_up .3s cubic-bezier(.22, .02, .13, .99) forwards;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseSimple\r\n{\r\n    animation:wr360_effect_pulse_simple var(--anim-duration) ease-out 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseOuter\r\n{\r\n    border-radius:50%;\r\n    animation:wr360_effect_pulse_outer var(--anim-duration) ease-out 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseRipple\r\n{\r\n    position:relative;\r\n    box-sizing:border-box;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseRipple::after,\r\n.wr360_player .container .indicator_effect_pulseRipple::before\r\n{\r\n    content:\"\";\r\n    position:absolute;\r\n    box-sizing:border-box;\r\n    top:0;\r\n    left:0;\r\n    width:100%;\r\n    height:100%;\r\n    border-radius:50%;\r\n    background:rgba(0,0,0,0);\r\n    border:1px solid #eee;\r\n    transform-origin:center;\r\n    animation:wr360_effect_pulse_ripple var(--anim-duration) linear 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseRipple::before\r\n{\r\n    animation-delay:1s;\r\n}\r\n\r\n.wr360_player .container .indicator_effect_pulseDoubleOuter\r\n{\r\n    border-radius:50%;\r\n    animation:wr360_effect_pulse_double_outer var(--anim-duration) ease-out 10ms infinite;\r\n}\r\n\r\n.wr360_player .container .hotspot_indicator_hidden\r\n{\r\n    display:none !important;\r\n}\r\n\r\n.wr360_player .container .indicator_link_wrap\r\n{\r\n    z-index:3;\r\n    position:absolute;\r\n}\r\n\r\n.wr360_player .container .indicator_link\r\n{\r\n    transform-origin:top left;\r\n    position:absolute;\r\n}\r\n\r\n.wr360_player .container .position_rollover\r\n{\r\n    position:absolute;\r\n    left:0;\r\n    top:0;\r\n    visibility:hidden;\r\n    z-index:15;\r\n    cursor:pointer;\r\n}\r\n\r\n.wr360_player .container .position_rollover > a\r\n{\r\n    display:inline-block;\r\n    box-sizing:border-box;\r\n    text-decoration:none;\r\n}\r\n\r\n.wr360_player .container .position_rollover > div\r\n{\r\n    box-sizing:border-box;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover\r\n{\r\n    z-index:18;\r\n    width:100%;\r\n    height:100%;\r\n    background-color:rgba(0, 0, 0, 1);\r\n    position:absolute;\r\n    top:0;\r\n    left:0;\r\n    display:none;\r\n    cursor:default;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover *,\r\n.wr360_player .container .lightbox_rollover2 *\r\n{\r\n    box-sizing:border-box;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover .closelbox\r\n{\r\n    position:absolute;\r\n    background:url(../img/all/lightbox_close.svg) 7px 7px no-repeat;\r\n    right:15px;\r\n    top:15px;\r\n    width:28px;\r\n    height:28px;\r\n    cursor:pointer;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover .closelbox:hover\r\n{\r\n    opacity:0.8;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover .img_wrap\r\n{\r\n    width:100%;\r\n    height:100%;\r\n    max-width:100%;\r\n    max-height:100%;\r\n    background-position:center center;\r\n    background-repeat:no-repeat;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover a.img_wrap\r\n{\r\n    display:block;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover .img_title\r\n{\r\n    position:absolute;\r\n    padding:0;\r\n    max-width:100%;\r\n    width:100%;\r\n    text-align:left;\r\n    bottom:0;\r\n    left:0;\r\n    background-color:rgba(65, 65, 65, 0.9);\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover .img_title a\r\n{\r\n    color:#ff0000;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover .img_title .usr_text\r\n{\r\n    display:inline-block;\r\n    color:#fff;\r\n    width:50%;\r\n    text-align:left;\r\n    padding:15px 20px 19px 20px;\r\n    line-height:19px;\r\n    font-size:16px;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover .img_title a.usr_text\r\n{\r\n    display:block;\r\n    text-decoration: none;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2\r\n{\r\n    position:relative;\r\n    padding:0;\r\n    width:100%;\r\n    height:100%;\r\n    top:0;\r\n    left:0;\r\n    z-index:18;\r\n    background:transparent;\r\n    display:flex;\r\n    align-items:center;\r\n    justify-content:center;\r\n    cursor:pointer;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_wrap\r\n{\r\n    width:100%;\r\n    height:100%;\r\n    position:relative;\r\n    cursor:auto;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .closelbox\r\n{\r\n    position:absolute;\r\n    right:7px;\r\n    top:7px;\r\n    width:26px;\r\n    height:26px;\r\n    opacity:1;\r\n    background:none;\r\n    cursor:pointer;\r\n    z-index:2;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .closelbox:hover\r\n{\r\n    opacity:0.7;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .closelbox > div\r\n{\r\n    position:absolute;\r\n    left:calc(50% - 1px);\r\n    height:100%;\r\n    width:2px;\r\n    background-color:#a3a3a3;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .closelbox div:nth-child(1)\r\n{\r\n    transform:rotate(45deg);\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .closelbox div:nth-child(2)\r\n{\r\n    transform:rotate(-45deg);\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_content\r\n{\r\n    width:100%;\r\n    height:100%;\r\n    position:relative;\r\n    z-index:1;\r\n    overflow:auto;\r\n    padding:0 5px 0 5px;\r\n    scrollbar-width:thin;\r\n    scrollbar-color:#b3b3b3 transparent;\r\n    cursor:auto;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_content::-webkit-scrollbar\r\n{\r\n    width:6px;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_content::-webkit-scrollbar-thumb\r\n{\r\n    background-color:#b3b3b3;\r\n    border-radius:6px;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 a.lbox2_content\r\n{\r\n    display:block;\r\n    text-decoration:none;\r\n    color:inherit;\r\n    cursor:pointer;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_content.lbox2_frame\r\n{\r\n    overflow:hidden;\r\n    padding:0;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_content iframe\r\n{\r\n    width:100%;\r\n    height:100%;\r\n    border:none;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_content img\r\n{\r\n    cursor:auto !important;\r\n}\r\n\r\n.wr360_player .container .lightbox_rollover2 .lbox2_wait\r\n{\r\n    position:absolute;\r\n    width:50px;\r\n    height:50px;\r\n    bottom:0;\r\n    top:0;\r\n    left:0;\r\n    right:0;\r\n    margin:auto;\r\n    background-color:#999;\r\n    border-radius:100%;\r\n    animation:wr360_popup_wait 0.9s infinite ease-in-out;\r\n    z-index:0;\r\n}\r\n\r\n@keyframes wr360_effect_pulse_ringed\r\n{\r\n    0%\r\n    {\r\n        box-shadow:0 0 1px 0 rgba(238, 238, 238, 0);\r\n    }\r\n    50%\r\n    {\r\n        box-shadow:0 0 1px 7px rgba(238, 238, 238, 0.6);\r\n    }\r\n    100%\r\n    {\r\n        box-shadow:0 0 1px 0 rgba(238, 238, 238, 0);\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_pulse_ringed_border\r\n{\r\n    0%\r\n    {\r\n        transform:scale(1);\r\n        border-color:rgba(200, 200, 200, 0);\r\n    }\r\n    50%\r\n    {\r\n        transform:scale(1.46);\r\n        border-color:rgba(200, 200, 200, 0.6);\r\n    }\r\n    100%\r\n    {\r\n        transform:scale(1);\r\n        border-color:rgba(200, 200, 200, 0);\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_spin\r\n{\r\n    100%\r\n    {\r\n        transform:rotate(360deg);\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_scale_up\r\n{\r\n    100%\r\n    {\r\n        transform:scale(1, 1);\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_pulse_simple\r\n{\r\n    0%, 100%\r\n    {\r\n        transform:scale(0.84);\r\n        opacity:0.85;\r\n    }\r\n\r\n    50%\r\n    {\r\n        transform:scale(1.0);\r\n        opacity:1;\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_pulse_outer\r\n{\r\n    0%\r\n    {\r\n        box-shadow: 0 0 1px 0 rgba(238, 238, 238, 1), 0 0 0 0 rgba(238, 238, 238, 0);\r\n    }\r\n    100%\r\n    {\r\n        box-shadow:0 0 1px 15px rgba(238, 238, 238, 0), 0 0 0 0 rgba(238, 238, 238, 0.7);\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_pulse_ripple\r\n{\r\n    0%\r\n    {\r\n        transform:scale(1);\r\n        opacity:0.9;\r\n    }\r\n    90%\r\n    {\r\n        transform:scale(2.0);\r\n        opacity:0;\r\n    }\r\n    100%\r\n    {\r\n        transform:scale(1);\r\n        opacity:0;\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_pulse_double_outer\r\n{\r\n    0%\r\n    {\r\n        box-shadow:0 0 0 1px rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0);\r\n    }\r\n    15%\r\n    {\r\n        box-shadow:0 0 0 5px rgba(238, 238, 238, 0.5), 0 0 3px 10px rgba(238, 238, 238, 0.5);\r\n    }\r\n    100%\r\n    {\r\n        box-shadow:0 0 0 4px rgba(0, 0, 0, 0), 0 0 3px 20px rgba(238, 238, 238, 0);\r\n    }\r\n}\r\n\r\n@keyframes wr360_popup_wait\r\n{\r\n    0%\r\n    {\r\n        transform:scale(0);\r\n        opacity:1;\r\n        border-color:rgba(253,253,253,1);\r\n    }\r\n    60%\r\n    {\r\n        transform:scale(0.8);\r\n        opacity:0.3;\r\n        border-color:rgba(253,253,253,0.8);\r\n    }\r\n    100%\r\n    {\r\n        transform:scale(1.0);\r\n        opacity:0;\r\n        border-color:rgba(253,253,253,0);\r\n    }\r\n}\r\n\r\n@keyframes wr360_effect_flash\r\n{\r\n    75%\r\n    {\r\n        opacity:1;\r\n    }\r\n    90%\r\n    {\r\n        opacity:0.1;\r\n    }\r\n}\r\n\r\n/* Skins */\r\n\r\n/* Basic */\r\n\r\n.wr360_player.basic .container .theme_panel_back\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:34px;\r\n    z-index:2;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:34px;\r\n    z-index:3;\r\n    cursor:pointer !important;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar\r\n{\r\n    position:relative;\r\n    height:34px;\r\n    padding:0 10px 0 10px;\r\n    margin:0 auto 0 auto;\r\n    box-sizing:content-box !important;\r\n    border:none !important;\r\n    background:inherit !important;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar > a\r\n{\r\n    transition:none !important;\r\n    display:block;\r\n    float:left;\r\n    width:22px;\r\n    height:24px;\r\n    margin:5px 0 0 11px;\r\n\topacity:0.7;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar > a:first-of-type\r\n{\r\n    margin-left:0;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.left_button\r\n{\r\n    background:url(../img/basic/left.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.right_button\r\n{\r\n    background:url(../img/basic/right.svg) no-repeat 0 0;\r\n    margin-right:2px;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.up_button\r\n{\r\n    background:url(../img/basic/up.svg) no-repeat 0 0;\r\n    margin-left:10px;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.down_button\r\n{\r\n    background:url(../img/basic/down.svg) no-repeat 0 0;\r\n    margin-left:7px;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.play_button\r\n{\r\n    background:url(../img/basic/play.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.pause_button\r\n{\r\n    background:url(../img/basic/pause.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.zoomin_button\r\n{\r\n    background:url(../img/basic/zoomin.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.basic .container_zoomoff .theme_panel .toolbar a.zoomin_button,\r\n.wr360_player.basic .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover\r\n{\r\n    cursor:default;\r\n    opacity:0.4;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.zoomout_button\r\n{\r\n    background:url(../img/basic/zoomout.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.hotspotson_button\r\n{\r\n    background:url(../img/basic/hotspoton.svg) no-repeat 0 0;\r\n    margin-left:8px;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.hotspotsoff_button\r\n{\r\n    background:url(../img/basic/hotspotoff.svg) no-repeat 0 0;\r\n    margin-left:8px;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n    background:url(../img/basic/fullscreenon.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.basic .container .theme_panel .toolbar > a:hover\r\n{\r\n\topacity:0.6;\r\n}\r\n\r\n/* Empty */\r\n\r\n.wr360_player.empty .container .theme_panel_back\r\n{\r\n    position:absolute;\r\n    width:0 !important;\r\n    bottom:0 !important;\r\n    left:0 !important;\r\n    margin:0 !important;\r\n    height:0 !important;\r\n    z-index:0 !important;\r\n}\r\n\r\n.wr360_player.empty .container .theme_panel\r\n{\r\n    position:absolute;\r\n    width:0 !important;\r\n    bottom:0 !important;\r\n    left:0 !important;\r\n    margin:0 !important;\r\n    height:0 !important;\r\n    z-index:0 !important;\r\n    cursor:pointer !important;\r\n}\r\n\r\n.wr360_player.empty .container .theme_panel .toolbar\r\n{\r\n    position:relative;\r\n    height:0 !important;\r\n    padding:0 !important;\r\n    margin:0 !important;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.empty .container .theme_panel .toolbar a.fullscreenoff_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.fullscreenon_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.hotspotsoff_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.hotspotson_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.zoomout_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.zoomin_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.right_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.pause_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.play_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.left_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.down_button,\r\n.wr360_player.empty .container .theme_panel .toolbar a.up_button\r\n{\r\n    background:none !important;\r\n    display:none !important;\r\n    width:0 !important;\r\n    height:0 !important;\r\n    margin:0 !important;\r\n}\r\n\r\n/* Retina */\r\n\r\n.wr360_player.retina .container .theme_panel_back\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:50px;\r\n    z-index:2;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0px;\r\n    left:0;\r\n    height:50px;\r\n    z-index:3;\r\n    cursor:pointer !important;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar\r\n{\r\n    position:relative;\r\n    height:42px;\r\n    padding:3px 10px 0 10px;\r\n    margin:0 auto 0 auto;\r\n    box-sizing:content-box !important;\r\n    border:none !important;\r\n    background:inherit !important;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar > a\r\n{\r\n    transition:none !important;\r\n    display:block;\r\n    float:left;\r\n    width:38px;\r\n    height:38px;\r\n    margin:3px 0 0 11px;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar > a:first-of-type\r\n{\r\n    margin-left:0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.left_button\r\n{\r\n    background:url(../img/retina/left.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.right_button\r\n{\r\n    background:url(../img/retina/right.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.up_button\r\n{\r\n    background:url(../img/retina/up.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.down_button\r\n{\r\n    background:url(../img/retina/down.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.play_button\r\n{\r\n    background:url(../img/retina/play.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.pause_button\r\n{\r\n    background:url(../img/retina/pause.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.zoomin_button\r\n{\r\n    background:url(../img/retina/zoomin.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container_zoomoff .theme_panel .toolbar a.zoomin_button,\r\n.wr360_player.retina .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover\r\n{\r\n    cursor:default;\r\n    opacity:0.4;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.zoomout_button\r\n{\r\n    background:url(../img/retina/zoomout.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.hotspotson_button\r\n{\r\n    background:url(../img/retina/hotspoton.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.hotspotsoff_button\r\n{\r\n    background:url(../img/retina/hotspotoff.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n    background:url(../img/retina/fullscreenon.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.retina .container .theme_panel .toolbar > a:hover\r\n{\r\n\topacity:0.8;\r\n}\r\n\r\n/* Round */\r\n\r\n.wr360_player.round .container .theme_panel_back\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:38px;\r\n    z-index:2;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:38px;\r\n    z-index:3;\r\n    cursor:pointer !important;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar\r\n{\r\n    position:relative;\r\n    height:29px;\r\n    padding:3px 10px 0 10px;\r\n    margin:0 auto 0 auto;\r\n    box-sizing:content-box !important;\r\n    border:none !important;\r\n    background:inherit !important;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar > a\r\n{\r\n    transition:none !important;\r\n    display:block;\r\n    float:left;\r\n    width:28px;\r\n    height:28px;\r\n    margin:2px 0 0 8px;\r\n    opacity:1;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar > a:first-of-type\r\n{\r\n    margin-left:0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.left_button\r\n{\r\n    background:url(../img/round/left.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.right_button\r\n{\r\n    background:url(../img/round/right.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.up_button\r\n{\r\n    background:url(../img/round/up.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.down_button\r\n{\r\n    background:url(../img/round/down.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.play_button\r\n{\r\n    background:url(../img/round/play.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.pause_button\r\n{\r\n    background:url(../img/round/pause.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.zoomin_button\r\n{\r\n    background:url(../img/round/zoomin.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container_zoomoff .theme_panel .toolbar a.zoomin_button,\r\n.wr360_player.round .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover\r\n{\r\n    cursor:default;\r\n    opacity:0.4;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.zoomout_button\r\n{\r\n    background:url(../img/round/zoomout.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.hotspotson_button\r\n{\r\n    background:url(../img/round/hotspoton.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.hotspotsoff_button\r\n{\r\n    background:url(../img/round/hotspotoff.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n    background:url(../img/round/fullscreenon.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.round .container .theme_panel .toolbar > a:hover\r\n{\r\n\topacity:0.8;\r\n}\r\n\r\n/* Thin */\r\n\r\n.wr360_player.thin .container .theme_panel_back\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:28px;\r\n    z-index:2;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:28px;\r\n    z-index:3;\r\n    cursor:pointer !important;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar\r\n{\r\n    position:relative;\r\n    height:28px;\r\n    padding:1px 10px 0 10px;\r\n    margin:0 auto 0 auto;\r\n    box-sizing:content-box !important;\r\n    border:none !important;\r\n    background:inherit !important;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar > a\r\n{\r\n    transition:none !important;\r\n    display:block;\r\n    float:left;\r\n    width:18px;\r\n    height:18px;\r\n    margin:4px 0 0 12px;\r\n    opacity:1;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar > a:first-of-type\r\n{\r\n    margin-left:0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.left_button\r\n{\r\n    background:url(../img/thin/left.svg) no-repeat 0 0;\r\n    margin-right:-2px;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.right_button\r\n{\r\n    background:url(../img/thin/right.svg) no-repeat 0 0;\r\n    margin-right:-1px;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.up_button\r\n{\r\n    background:url(../img/thin/up.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.down_button\r\n{\r\n    background:url(../img/thin/down.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.play_button\r\n{\r\n    background:url(../img/thin/play.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.pause_button\r\n{\r\n    background:url(../img/thin/pause.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.zoomin_button\r\n{\r\n    background:url(../img/thin/zoomin.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container_zoomoff .theme_panel .toolbar a.zoomin_button,\r\n.wr360_player.thin .container_zoomoff .theme_panel .toolbar a.zoomin_button:hover\r\n{\r\n    cursor:default;\r\n    opacity:0.4;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.zoomout_button\r\n{\r\n    background:url(../img/thin/zoomout.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.hotspotson_button\r\n{\r\n    background:url(../img/thin/hotspoton.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.hotspotsoff_button\r\n{\r\n    background:url(../img/thin/hotspotoff.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n    background:url(../img/thin/fullscreenon.svg) no-repeat 0 0;\r\n}\r\n\r\n.wr360_player.thin .container .theme_panel .toolbar > a:hover\r\n{\r\n\topacity:0.8;\r\n}\r\n\r\n/* Zoom Dark */\r\n\r\n.wr360_player.zoom_dark .container .theme_panel_back\r\n{\r\n\tdisplay:none;\r\n}\r\n\r\n.wr360_player.zoom_dark .container .theme_panel\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0;\r\n    left:0;\r\n    height:66px;\r\n    z-index:3;\r\n\tpointer-events:none;\r\n}\r\n\r\n.wr360_player.zoom_dark .container .theme_panel .toolbar\r\n{\r\n    position:relative;\r\n    padding:0 15px 0 15px;\r\n    margin:15px auto 0 auto;\r\n    box-sizing:content-box !important;\r\n    border:none !important;\r\n    background:inherit !important;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.zoom_dark .container .theme_panel .toolbar > a\r\n{\r\n    width:0;\r\n\theight:0;\r\n\tdisplay:none !important;\r\n    transition:none !important;\r\n}\r\n\r\n.wr360_player.zoom_dark .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n\twidth:36px;\r\n\theight:36px;\r\n    background:url(../img/zoom_dark/fullscreenon.svg) no-repeat center center;\r\n\tbackground-size:36px 36px;\r\n\tbackground-color:rgba(40,40,40,0.8);\r\n\tdisplay:block !important;\r\n\tcursor:pointer;\r\n\tpointer-events:auto;\r\n}\r\n\r\n/*\r\n.wr360_player.wr360_player_fs .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n    display:none !important;\r\n}*/\r\n\r\n.wr360_player.zoom_dark .container .theme_panel .toolbar > a:hover\r\n{\r\n\topacity:0.8;\r\n}\r\n\r\n/* Zoom Light */\r\n\r\n.wr360_player.zoom_light .container .theme_panel_back\r\n{\r\n\tdisplay:none;\r\n}\r\n\r\n.wr360_player.zoom_light .container .theme_panel\r\n{\r\n    position:absolute;\r\n    width:100%;\r\n    bottom:0px;\r\n    left:0;\r\n    height:66px;\r\n    z-index:3;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.zoom_light .container .theme_panel .toolbar\r\n{\r\n    position:relative;\r\n    padding:0 15px 0 15px;\r\n    margin:15px auto 0 auto;\r\n    box-sizing:content-box !important;\r\n    border:none !important;\r\n    background:inherit !important;\r\n    pointer-events:none;\r\n}\r\n\r\n.wr360_player.zoom_light .container .theme_panel .toolbar > a\r\n{\r\n    width:0;\r\n\theight:0;\r\n    display:none !important;\r\n    transition:none !important;\r\n}\r\n\r\n.wr360_player.zoom_light .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n\twidth:36px;\r\n\theight:36px;\r\n    background:url(../img/zoom_light/fullscreenon.svg) no-repeat 0 0;\r\n\tbackground-size:36px 36px;\r\n\tbackground-color:rgba(248,248,248,0.8);\r\n    display:block !important;\r\n    cursor:pointer;\r\n    pointer-events:auto;\r\n}\r\n\r\n/*\r\n.wr360_player.wr360_player_fs .container .theme_panel .toolbar a.fullscreenon_button\r\n{\r\n    display:none !important;\r\n}*/\r\n\r\n.wr360_player.zoom_light .container .theme_panel .toolbar > a:hover\r\n{\r\n\topacity:0.8;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
